import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import back from "../../../assets/back.svg";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import DoctorView from "../../../components/customer/doctorView";
import PharmacyView from "../../../components/customer/pharmacyView";
import CustomerOrdersTable from "../../../components/orderTables/customerOrderTable";
import {
  linkedCustomerDetail,
  linkedPharmacyDetail,
} from "../../../redux/actions/customerActions";
import "../customers.css";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import DivisionTable from "../divisionTable/divisionTable";
import AddDivisionModal from "../../../components/modals/Customer/addDivisionModal";
import PharmacyTypeModal from "../../../components/modals/Customer/pharmacyTypeModal";
import OnbaordPharmacyProductsTableModal from "../../../components/modals/Customer/onboardPharmacyProductTableModal";

const CustomerPharmacyView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [customerDetail, setCustomerDetail] = useState(null);
  const [userType, setuserType] = useState("");
  const [loading, setLoading] = useState(false);
  const [linkShow, setLinkShow] = useState(false);
  const [customerTypeShow, setCustomerTypeShow] = useState(false);
  const [productTableShow, setProductTableShow] = useState(false);
  const [divisionList, setDivisionList] = useState([]);

  useEffect(() => {
    setLoading(true);
    console.log(state);
    setuserType(state?.user_type);
    dispatch(linkedPharmacyDetail(state, onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setLoading(false);
    console.log(data.data.data);
    setCustomerDetail(data.data.data);
    let divisionArray = data.data.data.headQuaters.map((ele) => ({
      value: ele?.vendorDivision.id,
      label: ele?.vendorDivision.name,
    }));
    setDivisionList(divisionArray);
  };
  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  // console.log(userType);

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/customers/onboarded-pharmacy",
      breadcrumb: " / customers / onboarded pharmacy",
    },

    {
      path: "/customers/onboarded-pharmacy/view/:id",
      breadcrumb: customerDetail?.code
        ? ` / ${customerDetail?.code} - view`
        : " / view",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });
  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className=" d-flex justify-content-between m-1 mb-2">
                <AdminButton
                  background={"#7065e4"}
                  color="white"
                  width="150px"
                  onClick={() => setProductTableShow(true)}
                >
                  Products
                </AdminButton>

                <AdminButton
                  color={"#7065e4"}
                  width="200px"
                  onClick={() => setCustomerTypeShow(true)}
                >
                  Change Pharmacy Type
                </AdminButton>

                <AdminButton
                  color={"#7065e4"}
                  onClick={() =>
                    navigate(
                      `/customers/customer/version-history-detail/:${customerDetail.id}`,
                      {
                        state: {
                          user_type: customerDetail?.is_pharmacy
                            ? "pharmacy"
                            : "doctor",
                          pharmacy_id: customerDetail?.is_pharmacy
                            ? customerDetail.id
                            : null,
                          doctor_id: customerDetail?.is_pharmacy
                            ? null
                            : customerDetail.id,
                        },
                      }
                    )
                  }
                >
                  Version History
                </AdminButton>
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <div className="main-view-page scrolling">
                  {userType == "doctor" && (
                    <DoctorView customerDetail={customerDetail} />
                  )}
                  {userType == "pharmacy" && (
                    <PharmacyView customerDetail={customerDetail} />
                  )}
                  <div className="mb-4">
                    <div className="d-flex  justify-content-between text-center px-3 my-3 py-1 form-sub-details fw_600">
                      <div className=" d-flex align-items-center text-center">
                        Divisions
                      </div>

                      <div className=" d-flex justify-content-between mt-1 mb-1">
                        <AdminButton
                          color={"#7065e4"}
                          onClick={() => {
                            setLinkShow(true);
                          }}
                        >
                          Add Division
                        </AdminButton>
                      </div>
                    </div>
                  </div>
                  <div className="mb-5">
                    <DivisionTable
                      vendor_type={userType}
                      headQuaters={customerDetail?.headQuaters}
                    />
                  </div>
                  <div className="mb-4">
                    <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                      Order Analysis
                    </div>
                  </div>
                  <div className="mb-5">
                    <CustomerOrdersTable orderList={customerDetail?.orders} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <AddDivisionModal
        userType={userType}
        show={linkShow}
        handleClose={() => setLinkShow(false)}
        customerDetail={customerDetail}
        user_id={customerDetail?.id}
        refreshData={() => {
          dispatch(linkedCustomerDetail(state, onSuccess, onError));
        }}
        divisions={
          customerDetail?.headQuaters ? customerDetail?.headQuaters[0] : null
        }
        headquater={
          userType == "doctor"
            ? customerDetail?.doctorHeadQuaters
              ? customerDetail?.doctorHeadQuaters[0]
              : null
            : customerDetail?.pharmacyHeadQuaters[0]
        }
      />
      <PharmacyTypeModal
        code={customerDetail?.code}
        name={customerDetail?.pharmacy_name.toUpperCase()}
        show={customerTypeShow}
        handleClose={() => setCustomerTypeShow(false)}
      />
      <OnbaordPharmacyProductsTableModal
        divisionList={divisionList}
        state_id={customerDetail?.state_id}
        show={productTableShow}
        ShowClose={() => setProductTableShow(false)}
      />
    </>
  );
};

export default CustomerPharmacyView;
